import * as ToggleGroup from '@studio/design-system/toggle/group';
import type { ReactElement } from 'react';
import { useCallback, useState } from 'react';
import { Column, Exhibit } from './styled.jsx';

type State = [string, string];

/** `<Toggles>` exhibit. */
export const Toggles = (): ReactElement => {
  const [state, setState] = useState<State>(['alpha', 'good']);

  const handleChange = useCallback(
    (position: number) => (nextValue: string) => {
      if (nextValue) {
        setState(
          (µ) =>
            µ.map((currentValue, index) => (position === index ? nextValue : currentValue)) as State
        );
      }
    },
    []
  );

  return (
    <Exhibit title='Toggle Groups'>
      <Column className='gap-32'>
        <ToggleGroup.Container label='Phase'>
          <ToggleGroup.Root onValueChange={handleChange(0)} type='single' value={state[0]}>
            <ToggleGroup.Item value='alpha'>Alpha</ToggleGroup.Item>
            <ToggleGroup.Item value='beta'>Beta</ToggleGroup.Item>
          </ToggleGroup.Root>
        </ToggleGroup.Container>

        <ToggleGroup.Container label='Pick Two'>
          <ToggleGroup.Root defaultValue={['cheap', 'fast']} type='multiple'>
            <ToggleGroup.Item value='cheap'>Cheap</ToggleGroup.Item>
            <ToggleGroup.Item value='fast'>Fast</ToggleGroup.Item>
            <ToggleGroup.Item value='good'>Good</ToggleGroup.Item>
          </ToggleGroup.Root>
        </ToggleGroup.Container>

        <ToggleGroup.Container label='Quality'>
          <ToggleGroup.Root onValueChange={handleChange(1)} type='single' value={state[1]}>
            <ToggleGroup.Item value='good'>Good</ToggleGroup.Item>
            <ToggleGroup.Item value='better'>Better</ToggleGroup.Item>
            <ToggleGroup.Item disabled value='best'>
              Best
            </ToggleGroup.Item>
          </ToggleGroup.Root>
        </ToggleGroup.Container>

        <ToggleGroup.Root disabled type='single'>
          <ToggleGroup.Item value='this'>This</ToggleGroup.Item>
          <ToggleGroup.Item value='that'>That</ToggleGroup.Item>
        </ToggleGroup.Root>
      </Column>
    </Exhibit>
  );
};
